function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 4.13333C18 2.95513 17.0449 2 15.8667 2H4.13333C2.95513 2 2 2.95513 2 4.13333V15.8667C2 17.0449 2.95513 18 4.13333 18H15.8667C17.0449 18 18 17.0449 18 15.8667V4.13333ZM20.1493 8.00549L20 8V20H8L8.00549 20.1493C8.08183 21.1841 8.94564 22 10 22H20L20.1493 21.9945C21.1841 21.9182 22 21.0544 22 20V10L21.994 9.84335C21.9179 8.86123 21.1324 8.07802 20.1493 8.00549ZM16 4H4V16L10 11L16 16V4ZM14 7.5C14 6.67157 13.3284 6 12.5 6C11.6716 6 11 6.67157 11 7.5C11 8.32843 11.6716 9 12.5 9C13.3284 9 14 8.32843 14 7.5Z"
});

var SvgIOverlay = function SvgIOverlay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIOverlay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/i-overlay.1aa283e6.svg";
export { ForwardRef as ReactComponent };